import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

const CheckboxUnchecked = (props: IconSvgProps) => {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M5.33224 22.0096H18.6678C20.8859 22.0096 22 20.8869 22 18.7063V5.30328C22 3.12277 20.8859 2 18.6678 2H5.33224C3.12376 2 2 3.11409 2 5.30328V18.7063C2 20.8955 3.12376 22.0096 5.33224 22.0096ZM5.36022 20.4456C4.19283 20.4456 3.55438 19.8361 3.55438 18.6301V5.3795C3.55438 4.18315 4.19283 3.56401 5.36022 3.56401H18.6398C19.7898 3.56401 20.4456 4.18315 20.4456 5.3795V18.6301C20.4456 19.8361 19.7898 20.4456 18.6398 20.4456H5.36022Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
};

export default CheckboxUnchecked;
